import React, { useState } from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Collapse from 'react-bootstrap/Collapse';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { FileUploader } from "react-drag-drop-files";

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import { useTranslation } from 'react-i18next';

const MetalProfileCpCreation = ({
    id,
    profileInfo,
    setProfileInfo,
    availableStocksFile,
    setAvailableStocksFile,
    handleCpNameChange,
    handleSubmit,
}) => {

    const { i18n, t } = useTranslation();

    const [dialogOpen, setDialogOpen] = useState(false)
    const [dialogContent, setDialogContent] = useState(<div></div>)

    const [open, setOpen] = useState(true);

    const [optimizationLevel, setOptimizationLevel] = useState(3);

    const docsLink = `https://resources.tasnifer.com${i18n.language === "tr" ? "" : `/${i18n.language}`}/docs`;

    const optimizationLevelNames = {
        1: t("Hızlı 1"),
        2: t("Hızlı 2"),
        3: t("Standart"),
        4: t("Detaylı"),
    }

    let optimizationLevelDescription = "";
    if (optimizationLevel === 1) {
        optimizationLevelDescription = t("fast1Desc");
    } else if (optimizationLevel === 2) {
        optimizationLevelDescription = t("fast2Desc");
    } else if (optimizationLevel === 3) {
        optimizationLevelDescription = t("standardDesc");
    } else if (optimizationLevel === 4) {
        optimizationLevelDescription = t("detailedDesc");
    }

    return (
        <Container className="p-4 my-4 bg-white border" style={{
            minHeight: "max(70vh,600px)",
            minWidth: "80vw",
        }}>
            {dialogOpen &&
                <Dialog
                    maxWidth="xs"
                    fullWidth={true}
                    open={dialogOpen}
                    onClose={() => setDialogOpen(false)}>
                    <DialogContent>
                        {dialogContent}
                    </DialogContent>
                </Dialog>}
            <Form onSubmit={(e) => { handleSubmit(e, profileInfo, id, optimizationLevel) }}>
                <Row className='my-3'>
                    <Col md={3} className='d-flex align-items-center mb-2'>
                        <span
                            style={{
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                paddingLeft: "1rem"
                            }}
                        >
                            {t("Kesim Planı ismi")}:
                        </span>
                    </Col>
                    <Col md={9} className='d-flex align-items-center'>
                        <Form.Control
                            required
                            type="text"
                            placeholder={t("Kesim Planı ismi giriniz")}
                            maxLength={25}
                            onChange={handleCpNameChange}
                            style={{
                                fontSize: "1.5rem",
                                borderRadius: "0"
                            }}
                        />
                    </Col>
                </Row>

                <Row className='my-3'>
                    <Col md={3} className='d-flex align-items-center mb-2'>
                        <span
                            style={{
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                paddingLeft: "1rem"
                            }}
                        >
                            {t("Mevcut Stok Dosyası")}:
                        </span>
                    </Col>
                    <Col md={9} className='d-flex align-items-center'>

                        <FileUploader
                            handleChange={(file) => setAvailableStocksFile(file)}
                            types={["xlsx"]}
                            fileOrFiles={availableStocksFile}
                            maxSize={50} // MB
                            hoverTitle=" "
                            children={
                                <div style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minHeight: "130px",
                                    minWidth: "56vw",
                                    border: "2px dashed #ccc",
                                    backgroundColor: "#eaecef",
                                    padding: "20px",
                                }}>
                                    {availableStocksFile ? (
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <div>
                                                <span style={{ color: "#555555" }}>
                                                    {t("Yüklendi")}:{" "}
                                                </span>
                                                <span style={{ color: "#555555", fontWeight: "bold" }}>
                                                    {availableStocksFile.name}
                                                </span>
                                            </div>
                                            <div className='mt-2 text-center'>
                                                <span
                                                    style={{
                                                        color: "#555555",
                                                        fontSize: "0.8rem",
                                                    }}
                                                >
                                                    {t("Dosyayı değiştirmek için tekar tıklayın veya sürükleyin.")}
                                                </span>
                                            </div>
                                        </div>
                                    ) : (
                                        <span style={{ color: "#555555" }}>
                                            {t("Dosyayı buraya sürükleyin veya tıklayın.")}
                                        </span>
                                    )}
                                </div>
                            }
                        />
                    </Col>
                </Row>
                <div className='mb-3'>
                    <i className='d-flex justify-content-end'>{t("Stok dosyası yükleme ile ilgili detaylı bilgi için")}&nbsp;<a href={docsLink}>{t("tıklayınız")}</a>.</i>
                </div>

                <Container className='p-2' style={{
                    border: "1px solid #ced4db",
                }}>
                    <Row className="align-items-center" onClick={() => setOpen(!open)}>
                        <Col lg={11} xs={10} className='m-0 ps-4'>
                            <span
                                style={{
                                    fontSize: "1.5rem",
                                    fontWeight: "bold"
                                }}
                            >
                                {t("Profil bilgileri")}
                            </span>
                        </Col>
                        <Col lg={1} xs={2}>
                            {open ? (
                                <FiChevronUp
                                    style={{ cursor: 'pointer', fontSize: '1.5rem', fontWeight: 'bold' }}
                                />
                            ) : (
                                <FiChevronDown
                                    style={{ cursor: 'pointer', fontSize: '1.5rem', fontWeight: 'bold' }}
                                />
                            )}
                        </Col>
                    </Row>
                    <Collapse in={open}>
                        <div className="p-2 table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col" style={{ width: "10%" }}>{t("Profil")}</th>
                                        <th scope="col" style={{ width: "10%" }}>{t("Malzeme")}</th>
                                        <th scope="col" style={{ width: "15%" }}>{t("Optimizasyona Dahil Edilsin mi?")}</th>
                                        <th scope="col" style={{ width: "20%" }}>{t("Kesim Yapılacak Boy Uzunluğu")} (mm)</th>
                                        <th scope="col" style={{ width: "10%" }}>{t("Testere kalınlığı")} (mm)</th>
                                    </tr>
                                    {/* line for changing all at once: */}
                                    <tr>
                                        <th colSpan={2} className="text-center">
                                        </th>
                                        <td>
                                            <Form.Select

                                                value={profileInfo[0].include_in_optimization}
                                                onChange={(e) => {
                                                    setProfileInfo(
                                                        profileInfo.map((item) => {
                                                            return {
                                                                ...item,
                                                                include_in_optimization: e.target.value == 'true'
                                                            }
                                                        })
                                                    )
                                                }}
                                            >
                                                <option value={true}>{t("Evet")}</option>
                                                <option value={false}>{t("Hayır")}</option>
                                            </Form.Select>
                                        </td>
                                        <td>
                                            <Form.Control

                                                type="number"
                                                value={profileInfo[0].stock_length}
                                                onChange={(e) => {
                                                    setProfileInfo(
                                                        profileInfo.map((item) => {
                                                            return {
                                                                ...item,
                                                                stock_length: e.target.value
                                                            }
                                                        })
                                                    )
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <Form.Control

                                                type="number"
                                                value={profileInfo[0].blade_thickness}
                                                onChange={(e) => {
                                                    setProfileInfo(
                                                        profileInfo.map((item) => {
                                                            return {
                                                                ...item,
                                                                blade_thickness: e.target.value
                                                            }
                                                        })
                                                    )
                                                }}
                                            />
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {profileInfo.map((profile) => {
                                        return (
                                            <tr key={profile.group_id}>
                                                <td>{profile.profile}</td>
                                                <td>{profile.grade}</td>
                                                <td>
                                                    <Form.Select

                                                        value={profile.include_in_optimization}
                                                        onChange={(e) => {
                                                            setProfileInfo(
                                                                profileInfo.map((item) => {
                                                                    if (item.group_id === profile.group_id) {
                                                                        return {
                                                                            ...item,
                                                                            include_in_optimization: e.target.value
                                                                        }
                                                                    }
                                                                    return item;
                                                                })
                                                            )
                                                        }}
                                                    >
                                                        <option value={true}>{t("Evet")}</option>
                                                        <option value={false}>{t("Hayır")}</option>
                                                    </Form.Select>
                                                </td>
                                                <td>
                                                    <Form.Control

                                                        type="number"
                                                        value={profile.stock_length}
                                                        onChange={(e) => {
                                                            setProfileInfo(
                                                                profileInfo.map((item) => {
                                                                    if (item.group_id === profile.group_id) {
                                                                        return {
                                                                            ...item,
                                                                            stock_length: e.target.value
                                                                        }
                                                                    }
                                                                    return item;
                                                                })
                                                            )
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control

                                                        type="number"
                                                        value={profile.blade_thickness}
                                                        onChange={(e) => {
                                                            setProfileInfo(
                                                                profileInfo.map((item) => {
                                                                    if (item.group_id === profile.group_id) {
                                                                        return {
                                                                            ...item,
                                                                            blade_thickness: e.target.value
                                                                        }
                                                                    }
                                                                    return item;
                                                                })
                                                            )
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </Collapse>
                </Container>
                <Row className='py-4'>
                    <Col md={5} className='d-flex align-items-center mb-2'>
                        <span
                            style={{
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                paddingLeft: "1rem"
                            }}
                        >
                            {t("Optimizasyon Seviyesi")}:
                        </span>
                    </Col>
                    <Col md={7} className=''>
                        <Row>
                            <div className="mt-2 w-100">
                                <Form.Select
                                    aria-label="Optimization level"
                                    defaultValue={3}
                                    onChange={(e) => setOptimizationLevel(parseInt(e.target.value))}
                                >
                                    <option value={1}>🟢 {t("Hızlı 1")}</option>
                                    <option value={2}>🔵 {t("Hızlı 2")}</option>
                                    <option value={3}>🟠 {t("Standart")}</option>
                                    <option value={4}>🔴 {t("Detaylı")}</option>
                                </Form.Select>
                            </div>
                        </Row>
                        <Row>
                            <div style={{ minHeight: "5em", alignItems: "center", display: "flex" }}>
                                <i className="mt-2" style={{ color: "#555555" }}>
                                    <b>{optimizationLevelNames[optimizationLevel]}</b>:&nbsp;
                                    {optimizationLevelDescription}
                                </i>
                            </div>
                        </Row>
                    </Col>

                </Row>
                <div className='text-center mt-3'>
                    <Button variant="success" size="lg" type="submit">
                        {t("HESAPLA")}
                    </Button>
                </div>


            </Form>
        </Container>
    )
}

export default MetalProfileCpCreation;